import { CoCotizaciondetalle } from './../../../comercial/cotizacion/dominio/CoCotizaciondetalle';
import { CoAutorizacionDescuentoDetalleService } from './../../../comercial/coautorizaciondescuentodetalle/servicio/coautorizaciondescuentodetalle.servicio';
import { CoCotizacionServicio } from 'src/app/erp/comercial/cotizacion/servicio/cotizacion.service';
import { CoCotizacion } from './../../../comercial/cotizacion/dominio/CoCotizacion';
import { WhItemMastServicio } from './../servicio/WhItemMast.service';
import { CoDocumentoServicio } from './../../../comercial/codocumento/service/codocumento.service';
import { CoDocumento } from './../../../comercial/codocumento/dominio/CoDocumento';
import { PrincipalBaseComponent } from './../../../../util/PrincipalBaseComponent';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { NoAuthorizationInterceptor } from 'src/app/util/interceptor/NoAuthorizationInterceptor';
import { DtoWhItemList } from '../dominio/DtoWhItemList';

@Component({
    selector: 'app-item-detalle',
    templateUrl: './whitemmast-detalle.component.html'
})
export class WhItemDetalleComponent extends PrincipalBaseComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        noAuthorizationInterceptor: NoAuthorizationInterceptor,
        messageService: MessageService,
        private router: Router,
        private coCotizacionServicio: CoCotizacionServicio,
        private whItemMastServicio: WhItemMastServicio,
        private coDocumentoServicio: CoDocumentoServicio,
    ) { super(noAuthorizationInterceptor, messageService); }

    item: DtoWhItemList = new DtoWhItemList();
    documento: CoDocumento = new CoDocumento();
    cotizacion: CoCotizacion = new CoCotizacion();
    origen: string = '';
    verdescuentos: string;
    acction: string;
    claveAutorizacion: number;
    habilitarDescuento: Boolean = true;

    ngOnInit(): void {

        this.acction = this.route.snapshot.params['accion'];
        this.origen = this.route.snapshot.params['origen'] as string;
        this.verdescuentos = this.route.snapshot.params['verdescuentos'] as string;


        console.log(this.acction);

        if (this.acction === 'NUEVO') {
            this.nuevo(JSON.parse(this.route.snapshot.params['dto']) as DtoWhItemList,
                JSON.parse(this.route.snapshot.params['bean']) as CoDocumento);
        } else if (this.acction === 'EDITAR') {
            this.editar(JSON.parse(this.route.snapshot.params['dto']) as DtoWhItemList,
                JSON.parse(this.route.snapshot.params['bean']));
        } else {
            throw new Error('NO CONTROLADO AUN');
        }
    }

    nuevo(item: DtoWhItemList, bean: any) {
        this.whItemMastServicio.obtenerItem(item.item).then(
            resp => {
                this.item = resp;

                if (this.origen === 'PEDIDO') {
                    this.documento = bean;
                    this.documento.item = this.item.item;
                } else if (this.origen === 'COTIZACION') {
                    this.cotizacion = bean;
                    this.cotizacion.item = this.item.item;
                }

            }
        );
    }

    obtenerAutorizacion() {
        if (this.documento.claveAutorizacion === undefined || this.documento.claveAutorizacion === null) {
            this.mostrarMensajeAdvertencia('Por favor ingresar la contraseña para la autorizacion');
            return;
        }

        this.coDocumentoServicio.obtenerAutorizacionDescuento04(this.documento).then(
            resp => {
                if (resp !== null) {
                    this.documento = resp;
                    if (resp.descuento04flag === 'S') {
                        this.habilitarDescuento = false;
                        this.item.porcentajedescuento04 = resp.descuento04;
                    }
                }
            }
        ).catch(error => {
            this.mostrarMensajeAdvertencia(error);
            this.desbloquearPagina();
        });
    }

    editar(item: DtoWhItemList, bean: any) {
        this.item = item;
        if (this.origen === 'PEDIDO') {
            this.documento = bean;
            this.documento.item = this.item.item;
        } else if (this.origen === 'COTIZACION') {
            this.cotizacion = bean;
            this.cotizacion.item = this.item.item;
        }
    }

    validar(): Boolean {
        let valida: Boolean = false;
        if (!this.habilitarDescuento) {
            if (this.item.porcentajedescuento04 > this.documento.descuento04) {
                this.mostrarMensajeAdvertencia('El % #4 ingresado excede al máximo permitido x Item ' + this.documento.descuento04);
                valida = true;
            }
        }

        if (this.item.porcentajedescuento02_Valid === null || this.item.porcentajedescuento02_Valid === undefined) {
            this.item.porcentajedescuento02_Valid = 0;
        }
        if (this.item.porcentajedescuento02 > this.item.porcentajedescuento02_Valid) {
            this.mostrarMensajeAdvertencia('El % #2 ingresado excede al máximo permitido x Item ' + this.item.porcentajedescuento02_Valid);
            valida = true;
        }

        if (this.item.porcentajedescuento03_Valid === null || this.item.porcentajedescuento03_Valid === undefined) {
            this.item.porcentajedescuento03_Valid = 0;
        }
        if (this.item.porcentajedescuento03 > this.item.porcentajedescuento03_Valid) {
            this.mostrarMensajeAdvertencia('El % #3 ingresado excede al máximo permitido x Item ' + this.item.porcentajedescuento03_Valid);
            valida = true;
        }

        return valida;
    }

    agregar() {

        if (this.validar()) {
            return;
        }


        if (this.item.cantidad === undefined || this.item.cantidad === null) {
            this.mostrarMensajeAdvertencia('Por favor ingresar la cantidad');
            return;
        }

        if (this.origen === 'PEDIDO') {
            this.bloquearPagina();
            this.documento.cantidad = this.item.cantidad;

            if (this.acction === 'NUEVO') {
                this.documento.iv_action = 'Add';
                this.coDocumentoServicio.registrarPedido(this.documento).then(
                    resp => {
                        this.documento = resp;
                        this.desbloquearPagina();
                        this.mostrarMensajeExito('El Item N°' + this.documento.item + ' se ha agregado Correctamente');
                        this.router.navigate(['royal/item-listado', this.origen, this.documento.almacencodigo, JSON.stringify(resp), this.acction, 'N'], { skipLocationChange: true });
                    }
                );
            } else if (this.acction === 'EDITAR' && this.verdescuentos === 'N') {
                this.documento.iv_action = 'Add';
                this.coDocumentoServicio.registrarPedido(this.documento).then(
                    resp => {
                        this.documento = resp;
                        this.desbloquearPagina();
                        this.mostrarMensajeExito('El Item N°' + this.documento.item + ' se ha agregado Correctamente');
                        this.router.navigate(['royal/item-listado', this.origen, this.documento.almacencodigo, JSON.stringify(resp), this.acction, 'N'], { skipLocationChange: true });
                    }
                );
            } else if (this.acction === 'EDITAR' && this.verdescuentos === 'S') {
                this.documento.cantidadItem = this.item.cantidad;
                this.documento.descuento01 = this.item.porcentajedescuento01;
                this.documento.descuento02 = this.item.porcentajedescuento02;
                this.documento.descuento03 = this.item.porcentajedescuento03;
                this.documento.descuento04 = this.item.porcentajedescuento04;
                this.documento.iv_action = 'U';
                this.whItemMastServicio.calcularMontos(this.documento).then(
                    resp => {
                        this.documento = resp;
                        this.desbloquearPagina();
                        this.mostrarMensajeExito('El Item N°' + this.documento.item + ' se ha actualizado Correctamente');
                        this.router.navigate(['royal/pedido-mantenimiento', 'VERITEMS', JSON.stringify(this.documento), this.acction], { skipLocationChange: true });
                    }
                );

            }

        } else if (this.origen === 'COTIZACION') {
            this.bloquearPagina();
            this.cotizacion.cantidad = this.item.cantidad;

            if (this.acction === 'NUEVO') {
                this.cotizacion.iv_action = 'Add';
                this.coCotizacionServicio.registrarDetalle(this.cotizacion).then(
                    resp => {
                        this.cotizacion = resp;
                        this.desbloquearPagina();
                        this.mostrarMensajeExito('El Item N°' + this.cotizacion.item + ' se ha agregado Correctamente');
                        this.router.navigate(['royal/item-listado', this.origen, this.cotizacion.almacencodigo, JSON.stringify(resp), this.acction, 'N'], { skipLocationChange: true });
                    }
                );
            } else if (this.acction === 'EDITAR' && this.verdescuentos === 'N') {
                this.cotizacion.iv_action = 'Add';
                this.coCotizacionServicio.registrarDetalle(this.cotizacion).then(
                    resp => {
                        this.cotizacion = resp;
                        this.desbloquearPagina();
                        this.mostrarMensajeExito('El Item N°' + this.cotizacion.item + ' se ha agregado Correctamente');
                        this.router.navigate(['royal/item-listado', this.origen, this.cotizacion.almacencodigo, JSON.stringify(resp), this.acction, 'N'], { skipLocationChange: true });
                    }
                );
            } else if (this.acction === 'EDITAR' && this.verdescuentos === 'S') {
                this.cotizacion.cantidadItem = this.item.cantidad;
                this.cotizacion.descuento01 = this.item.porcentajedescuento01;
                this.cotizacion.descuento02 = this.item.porcentajedescuento02;
                this.cotizacion.descuento03 = this.item.porcentajedescuento03;
                this.cotizacion.descuento04 = this.item.porcentajedescuento04;
                this.cotizacion.iv_action = 'U';
                this.whItemMastServicio.calcularMontosCotizacion(this.cotizacion).then(
                    resp => {
                        this.cotizacion = resp;
                        this.desbloquearPagina();
                        this.mostrarMensajeExito('El Item N°' + this.cotizacion.item + ' se ha actualizado Correctamente');
                        this.router.navigate(['royal/cocotizacion-mantenimiento', 'VERITEMS', JSON.stringify(this.cotizacion), this.acction], { skipLocationChange: true });
                    }
                );

            }
        }
    }

    calcularMontosEditar() {
        if (this.validar()) {
            return;
        }
        if (this.origen === 'PEDIDO') {

            this.documento.cantidadItem = this.item.cantidad;
            this.documento.descuento01 = this.item.porcentajedescuento01;
            this.documento.descuento02 = this.item.porcentajedescuento02;
            this.documento.descuento03 = this.item.porcentajedescuento03;
            this.documento.descuento04 = this.item.porcentajedescuento04;
            this.documento.iv_action = 'U';
            this.whItemMastServicio.calcularMontos(this.documento).then(
                resp => {
                    this.documento = resp;
                }
            );
        } else if (this.origen === 'COTIZACION') {
            this.cotizacion.cantidadItem = this.item.cantidad;
            this.cotizacion.descuento01 = this.item.porcentajedescuento01;
            this.cotizacion.descuento02 = this.item.porcentajedescuento02;
            this.cotizacion.descuento03 = this.item.porcentajedescuento03;
            this.cotizacion.descuento04 = this.item.porcentajedescuento04;
            this.cotizacion.iv_action = 'U';
            this.whItemMastServicio.calcularMontosCotizacion(this.cotizacion).then(
                resp => {
                    if (resp !== null) {
                        this.cotizacion = resp;
                    }
                }
            );
        }
    }

    cancelar() {
        if (this.origen === 'PEDIDO') {
            this.router.navigate(['royal/pedido-mantenimiento', 'VERITEMS', JSON.stringify(this.documento), this.acction], { skipLocationChange: true });
        } else {
            this.router.navigate(['royal/cocotizacion-mantenimiento', 'VERITEMS', JSON.stringify(this.cotizacion), this.acction], { skipLocationChange: true });
        }
    }



}
